import { type EmployeeDetailsTab } from './constants';

export const getTabId = (tab: EmployeeDetailsTab) => `employee-details-tab-${tab}`;

export const getTabPanelId = (tab: EmployeeDetailsTab) => `employee-details-tabpanel-${tab}`;
